<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="90px" :rules="rules">
      <el-form-item label="所属客户" prop="new_owner_org_id">
        <el-select filterable v-model="ruleForm.new_owner_org_id" @change="newOwnerOrgIdChange">
          <el-option
            v-for="item in ownerOrgList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="安装时间" prop="new_install_time">
        <el-date-picker
          v-model="ruleForm.new_install_time"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="安装地址" prop="new_install_address">
        <el-input v-model="ruleForm.new_install_address" />
      </el-form-item>
      <el-form-item label="联系人" prop="new_contact_name">
        <el-input v-model="ruleForm.new_contact_name" />
      </el-form-item>
      <el-form-item label="联系电话" prop="new_contact_mobile">
        <el-input v-model="ruleForm.new_contact_mobile" />
      </el-form-item>
      <el-form-item label="合作模式" prop="new_device_purpose">
        <el-select v-model="ruleForm.new_device_purpose">
          <el-option
            v-for="item in devicePurpose"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog cz" @click="resetForm">重置</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'

export default {
  name: '',
  data () {
    return {
      devicePurpose: BasicDataHelper.devicePurpose,
      ruleForm: {
        new_owner_org_id: '',
        new_owner_org_name: '',
        new_install_time: '',
        new_install_address: '',
        new_contact_name: '',
        new_contact_mobile: '',
        new_device_purpose: ''
      },
      rules: {
        new_owner_org_id: [
          { required: true, message: '请选择所属客户', trigger: 'change' }
        ],
        new_device_purpose: [
          { required: true, message: '请选择合作模式', trigger: 'change' }
        ]
      }
    }
  },

  props: {
    deviceId: {
      default: '',
      type: String
    },
    ownerOrgList: {
      default: () => [],
      type: Array
    }
  },

  methods: {
    newOwnerOrgIdChange (id) {
      if (id !== '') {
        this.ruleForm.new_owner_org_name = this.ownerOrgList.find(it => {
          return it.value === id
        }).text
      } else {
        this.ruleForm.new_owner_org_name = ''
      }
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
      this.ruleForm.new_owner_org_name = ''
    },
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = { device_id: this.deviceId, ...this.ruleForm }
          Backend.post(this, 'device_transfer_recorder/transfer_device', params).then((res) => {
            this.$message.success('设备转移成功!')
            this.$emit('tableCloseDialog')
          })
        }
      })
    }
  }
}
</script>
